import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { compose, withProps } from 'recompose';
import { PaymentMethodSelect, IPaymentMethodSelectProps } from './PaymentMethodSelect';
import * as _ from 'lodash';

const GetPaymentMethodsListQuery = gql`
  query ($domain: String!) {
    paymentMethods(where: { eshop: { domain: $domain }}) {
      id
      title
      name
      price
    }
  }
`;

export default withRouter(compose<{}, IPaymentMethodSelectProps>(
  graphql<IPaymentMethodSelectProps, any>(GetPaymentMethodsListQuery, {
    name: 'methods',
    options: props => ({
      variables: {
        domain: props.match.params.eshop
      }
    })
  }),
  withProps(({ methods }: any) => {
    return {
      methods: methods.paymentMethods,
    };
  }),
)(PaymentMethodSelect));



// WEBPACK FOOTER //
// ./src/components/Others/PaymentMethodSelect/index.ts